import { render, staticRenderFns } from "./componente-setorvenda.vue?vue&type=template&id=d914ef30"
import script from "./componente-setorvenda.vue?vue&type=script&lang=js"
export * from "./componente-setorvenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports